// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".appointment-inputs[data-v-7a59e9c0]{max-width:300px;margin:0 auto;display:flex;flex-direction:column;gap:16px}", ""]);
// Exports
module.exports = exports;
